module.exports = __webpack_public_path__ + "static/thales-ee8e77fb9fec9c50e98ea5fcbae89212.png";